module.exports = __webpack_public_path__ + "static/media/fly0179.061cf71c.webp";